import { POWER_SEARCH_RESOURCE_TYPE } from '../PowerSearch/utils'

export const mappedResourceTypes = Object.values(POWER_SEARCH_RESOURCE_TYPE)

export const DEFAULT_HOVER_VALUE = -1
